import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import App from './app'
import store from '@/store'
import router from './plugins/router'

import './plugins/autosize'
import './plugins/axios'
import './plugins/component-css-class'
import './plugins/ga'
import './plugins/live-coach'
import './plugins/notifications'
import './plugins/activity-notes'
import './plugins/activity-summary'
import './plugins/sentry'
import './plugins/toggle-button'
import './plugins/vee-validate'
import './plugins/vue-components'
import './plugins/vue-directive-long-press'
import './plugins/vue-modal-dialogs'
import './plugins/vue-tippy'

import './directives/focus'

Vue.use(VueCompositionAPI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js